import { isStrayCypherExpr } from './stray'

/**
 * Detail bundle for a single `:Process` (`$processId` param).
 *
 * Returns:
 *   - `p`               — the process node itself
 *   - `parent`          — the parent `:Process` reached via
 *                         `<-[:HAS_SUBPROCESS]-`, if any
 *   - `subprocesses[]`  — direct `HAS_SUBPROCESS` children
 *   - `implementations` — for every `:Line` that `INSTANTIATES` this
 *                         process across all sites, a row with:
 *                           - `line`           the line node
 *                           - `site`           the owning site
 *                                              (walked via
 *                                              `top` line that is
 *                                              NOT a subline →
 *                                              `Site -[:HAS_LINE]-> top`)
 *                           - `sublineParent`  the immediate
 *                                              `:Line` parent if
 *                                              this implementation
 *                                              is a subline
 *
 * Bounded by `LIMIT 10000`.
 */
export const PLANT_PROCESS_DETAIL_CYPHER = `
            MATCH (p:Process {id: $processId})
            OPTIONAL MATCH (parent:Process)-[:HAS_SUBPROCESS]->(p)
            OPTIONAL MATCH (p)-[:HAS_SUBPROCESS]->(child:Process)
            WITH p, parent, collect(distinct child) AS subprocesses
            OPTIONAL MATCH (impl:Line)-[:INSTANTIATES]->(p)
            OPTIONAL MATCH (top:Line)-[:HAS_SUBLINE*0..]->(impl)
              WHERE NOT (:Line)-[:HAS_SUBLINE]->(top)
            OPTIONAL MATCH (site:Site)-[:HAS_LINE]->(top)
            OPTIONAL MATCH (sublineParent:Line)-[:HAS_SUBLINE]->(impl)
            WITH p, parent, subprocesses,
                 collect(distinct {
                   line: impl,
                   site: site,
                   sublineParent: sublineParent
                 }) AS implementations
            RETURN p,
                   parent,
                   subprocesses,
                   implementations,
                   ${isStrayCypherExpr('p', 'Process')} AS isStray
            LIMIT 10000
          `
